import React from 'react';
import { motion } from 'framer-motion';
import type { FiltekProduct } from '../../types/filtek';
interface ProductGlyphProps {
  form: FiltekProduct['form'];
  accent: string;
  className?: string;
}

/**
 * A drawn delivery-form glyph rather than product packaging — the pack only
 * needs to say "syringe, capsule or flowable" at this point in the story.
 */
export function ProductGlyph({
  form,
  accent,
  className = ''
}: ProductGlyphProps) {
  const tipLong = form === 'flowable';
  return <svg viewBox="0 0 120 240" className={className} role="img" aria-label={`${form} delivery form`} data-id="element-418" data-mp="y7e5x6ln2rbw">
      <g stroke="var(--enamel)" strokeOpacity="0.35" strokeWidth="1.25" fill="none" data-id="element-419" data-mp="t9l0wgw2o3d7">
        {/* plunger */}
        <rect x="54" y="6" width="12" height="34" rx="3" data-id="element-420" data-mp="obb6w9m338t6" />
        <rect x="38" y="40" width="44" height="7" rx="3" data-id="element-421" data-mp="k8mtdomfddpv" />
        {/* barrel */}
        <rect x="42" y="47" width="36" height={form === 'bulk' ? 108 : 116} rx="8" data-id="element-422" data-mp="f91tnbzfl1c3" />
      </g>

      {/* material inside the barrel */}
      <motion.rect x="44.5" width="31" rx="6" fill={accent} fillOpacity="0.32" initial={{
      height: 0,
      y: form === 'bulk' ? 155 : 163
    }} animate={{
      height: form === 'bulk' ? 74 : 82,
      y: form === 'bulk' ? 81 : 81
    }} transition={{
      duration: 1.1,
      ease: [0.16, 1, 0.3, 1],
      delay: 0.2
    }} data-id="element-423" data-mp="3oruvnx231u7i" />

      <g stroke="var(--enamel)" strokeOpacity="0.35" strokeWidth="1.25" fill="none" data-id="element-424" data-mp="bdhvjogmrj19">
        {form === 'bulk' ? <>
            <path d="M46 155 h28 l-6 20 h-16 z" data-id="element-425" data-mp="gckmy63otqqr" />
            <rect x="52" y="175" width="16" height="26" rx="4" data-id="element-426" data-mp="2dladwtg92ay" />
          </> : <>
            <path d="M46 163 h28 l-8 16 h-12 z" data-id="element-427" data-mp="7c62ta2gmhou" />
            <rect x="55" y="179" width="10" height={tipLong ? 40 : 22} rx="4" data-id="element-428" data-mp="7auz1a90l9xq" />
          </>}
      </g>

      {tipLong && <motion.circle cx="60" cy="224" r="5" fill={accent} fillOpacity="0.75" initial={{
      r: 0,
      opacity: 0
    }} animate={{
      r: [0, 5, 4.4],
      opacity: [0, 1, 0.85]
    }} transition={{
      duration: 1.6,
      delay: 1,
      ease: 'easeOut'
    }} data-id="element-429" data-mp="2s2n8ylpq9f20" />}
    </svg>;
}